import { Component } from '@angular/core';
import {
  BaseComponent
} from 'base-form';

@Component({
  selector: 'mfpc-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent extends BaseComponent {
}
